import { AfterViewInit, ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import { LoadingService, ViewType } from '@finra/rampdi-forms-common';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { FormSelectorBaseComponent, Instance, InstanceResolveData } from '@finra/rampdi-forms-common';
import { CompletenessCheckService } from '../../services/completeness-check.service';
import { InstanceService, MU1WithSupportingData } from '../../services/instance.service';
import { NavigationDataService } from '../../services/navigation-data.service';
import { RedlineService } from '../../services/redline.service';
import { SchemaService } from '../../services/schema.service';
import { OverlayService } from '@finra/forms';
import { BehaviorSubject, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';
import { ProfilesService } from '../../services/profile.service';
import { HostApiService } from 'lib-host-interface';

export enum EmploymentStatus {
  UNLINKED = 'Self-Reported',
  GAP = 'Self-Reported',
  LINKED = 'Federal Registration',
  PLACEHOLDER = 'Pending Company Action',
  COMPANYRELATIONSHIP = 'Pending Form Submission',
  COMPANYRELATIONSHIP_ATTESTED = 'Verified',
}

@Component({
  selector: 'app-form-selector',
  templateUrl: './form-selector.component.html',
  styleUrls: ['./form-selector.component.scss'],
  host: {
    '(window:resize)': 'getMobileScreenSize($event)',
  },
  providers: [DatePipe],
})
export class FormSelectorComponent
  extends FormSelectorBaseComponent<
    MU1WithSupportingData,
    Instance<any>,
    InstanceResolveData<MU1WithSupportingData, Instance<any>>
  >
  implements OnInit, OnDestroy, AfterViewInit
{
  setOptions(params: ParamMap, data: any, showRedlines: any) {}
  hostApi: HostApiService = inject(HostApiService);
  private isDestroying$ = new Subject<void>();

  // Add missing properties with proper typing
  $infoMessage = new BehaviorSubject<{ showMessage: boolean; message: string }>({ showMessage: false, message: '' });
  $http = new BehaviorSubject<{ loading: boolean; error: any; data: any; isEmpty: boolean }>({
    loading: false,
    error: null,
    data: null,
    isEmpty: false,
  });
  $state = new BehaviorSubject<{ loading: boolean; error: any; exam: any; form: any }>({
    loading: false,
    error: null,
    exam: null,
    form: null,
  });

  // Expose as observables for template
  infoMessage$ = this.$infoMessage.asObservable();
  http$ = this.$http.asObservable();
  state$ = this.$state.asObservable();

  customComponent = [];
  formTemplateVersion: string;

  addedComponents = [...this.addedComponents, ...this.customComponent];

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected location: Location,
    protected LS: LoadingService,
    protected SS: SchemaService,
    protected CC: CompletenessCheckService,
    protected RL: RedlineService,
    protected OS: OverlayService,
    protected NS: NavigationDataService,
    protected IS: InstanceService,
    protected PS: ProfilesService,
    private cdr: ChangeDetectorRef,
  ) {
    super(route, router, location, SS, CC, RL, OS, NS, IS);
  }
  ngOnDestroy(): void {}
  ngAfterViewInit(): void {}
  customStyleForDefinedTermsTooltip: string[] = [
    'vertical-align: baseline',
    'line-height: inherit',
    'position: relative',
    'contain: paint',
    'padding-bottom: 3px',
  ];

  showValidationOnCC$$ = toSignal(
    this.CC.completenessCheck$.pipe(
      takeUntil(this.isDestroying$),
      map((resp) => (resp['open'] ? resp['open'] : false)),
    ),
  );

  refreshFormData() {
    this.formInfo$ = this.getFormInfo().pipe(
      map((formInfo) => {
        const params = this.route.snapshot.paramMap;
        const sectionId = params.get('sectionId');
        const licenseTypeCode = params.get('licenseTypeCode');
        const viewType = params.get('viewType') as ViewType;
        const navId = sectionId + (licenseTypeCode ? `;${licenseTypeCode}` : '');
        this.IS.viewType = viewType;
        this.sectionData = this.NDS.getNavItem(
          `${viewType}.${this.route.snapshot.data.instanceData?.instance?.instanceMetadata?.attributes?.filingTypeCode}`,
          navId,
        );
        return formInfo;
      }),
    );
  }

  getMobileScreenSize(event?) {
    if (window.innerWidth < 1140) {
      return true;
    } else {
      return false;
    }
  }

  ngOnInit(): void {
    this.getMobileScreenSize();
    this.formInfo$ = this.getFormInfo().pipe(
      map((formInfo) => {
        const params = this.route.snapshot.paramMap;
        const sectionId = params.get('sectionId');
        const licenseTypeCode = params.get('licenseTypeCode');
        const viewType = params.get('viewType') as ViewType;
        const navId = sectionId + (licenseTypeCode ? `;${licenseTypeCode}` : '');
        this.IS.viewType = viewType;
        this.sectionData = this.NDS.getNavItem(
          `${viewType}.${this.route.snapshot.data.instanceData?.instance?.instanceMetadata?.attributes?.filingTypeCode}`,
          navId,
        );
        return formInfo;
      }),
    );
  }

  getFormVersion() {
    return this.formTemplateVersion;
  }
  onDataChange(data: any) {
    console.log('Data Changed', data);
  }
  onStatusChange(status) {
    console.log('Status Changed', status);
  }
}
